var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"err-404"},[_c('img',{attrs:{"src":require("@/assets/images/error.jpg")}}),_c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.toHome}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }